import { boardMarketActionTypes } from "../actions/boardMarketdActions";
import { symbolActionTypes } from "../actions/symbolActions";
const initState = {
    initTime: 0,
    updateTime: 0,
    boardInfosTPRL: [],
    marketTRPLInfo: []
};

export const boardMarketReducer = (state = initState, { type, payload }) => {
    switch (type) {
        case boardMarketActionTypes.UpdateBoardTPRL:
            return {
                ...state,
                boardInfosTPRL: payload.data,
                initTime: payload.isInit ? (new Date()).getTime() : state.initTime,
                updateTime: (new Date()).getTime()
            };
        case boardMarketActionTypes.updateMarketTPRL:
            return {
                ...state,
                marketTRPLInfo: payload.data,
                initTime: payload.isInit ? (new Date()).getTime() : state.initTime,
                updateTime: (new Date()).getTime()
            };
        default:
            return state;
    }
};

